import {
    Location,
    OpenAPI,
    LocationService
} from '../openapi';
import { ApiResult } from '../openapi/core/ApiResult';
import { PropertyInfo } from '../openapi/models/PropertyInfo';

const { get, get1, getTotalCount, put, post, propertyInfo } = LocationService;

OpenAPI.BASE = process.env.REACT_APP_API_ENDPOINT as string;

export const getLocations = async (token: string, range: string, filter?: Record<string, string>, search?: Record<string, string>) => {
    const locations: ApiResult = await get(token, range, filter, search);
    return locations;
};

export const getLocationCount = async (token: string, filter?: Record<string, string>, search?: Record<string, string>): Promise<string> => {
    const result: string = await getTotalCount(token, filter, search);
    const count = result.split('/')[1];
    return count;
};

export const getLocationById = async (token: string, id: string): Promise<Location> => {
    return await get1(token, id);
};

export const updateLocation = async (
    token: string,
    id: number,
    location: Location
): Promise<Location> => {
    const l = { ...location };
    return await put(token, id, l);
};

export const addLocation = async (token: string, newLocation: Location): Promise<number> => {
    // Use fetch to create; return created id (API returns id as JSON number)
    const url = `${OpenAPI.BASE}/api/Locations`;
    const resp = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(newLocation)
    });

    if (!resp.ok) {
        const txt = await resp.text();
        throw new Error(txt || `HTTP ${resp.status}`);
    }

    const id = await resp.json();
    return id;
};

export const getPropertyInfo = async (token: string): Promise<Record<string, PropertyInfo>> => {
    return await propertyInfo(token);
};